import { InjectionToken } from "@angular/core";

export interface KeycloakConfig {
  url: string;
  realm: string;
  clientId: string;
}

export const KEYCLOAK_CONFIG = new InjectionToken<KeycloakConfig>(
  "KEYCLOAK_CONFIG"
);
